import React from 'react'
import GenerateNewKey from './GenerateNewKey'
import ApiKeys from './ApiKeys'

const API = () => {
  return (
    <>
      <ApiKeys />
      <GenerateNewKey />
    </>
  )
}

export default API
